import { render, staticRenderFns } from "./passResetOkPage.vue?vue&type=template&id=64fbcaaf&scoped=true&"
import script from "./passResetOkPage.vue?vue&type=script&lang=ts&"
export * from "./passResetOkPage.vue?vue&type=script&lang=ts&"
import style0 from "./passResetOkPage.vue?vue&type=style&index=0&id=64fbcaaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fbcaaf",
  null
  
)

export default component.exports